import { Modal } from "@mui/material";


export default function MuiModal({children, ...rest}: any) {
    return (
        <Modal {...rest} >
            {children}
        </Modal>
    )
}